export default {
  getAllNotifications: '/notifications/getAllNotifications',
  getNotificationsForADay: '/notifications/getAllNotificationsForADayForAUser'
}
